import styled from "styled-components";

export const Container = styled.button`
  background-image: url("./images/back_button.svg");
  background-color: transparent;
  height: 64px;
  margin: 15px;
  width: 64px;
`;
